import { useQuery } from '@tanstack/react-query';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantTables } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

export const useTables = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery([QUERIES.TABLES, orgSlug, restaurantId], () => tenantTables({ orgSlug, restaurantId }));
};
